
import t from './translateUtil'

const validNotMatch = value => compareValue => {
  if(compareValue && compareValue !== value.compareValue)
    return value.message
  return undefined;
}
const validNotMatchPassword = (value, compareValue) => {
  if (compareValue && compareValue !== value) {
    return t("Passwords must match"); 
  }
  return undefined;
};
const required = value => (value ? undefined : t("Required"));
const mustBeNumber = value => (value&&isNaN(value) ? t("Must be a number") : undefined);
const mustBeNumberRequired = value => (!value||!/^[0-9]+$/.test(value) ? t("Must be a number") : undefined);
const minValue = min => value =>
  isNaN(value) || value >= min ? undefined : `Should be greater than ${min}`;

const minFloatValue = min => value =>
  isNaN(value) || isNaN(min) || Number.parseFloat(value) >= Number.parseFloat(min) ? undefined : `Should be greater than ${min}`;

const maxValue = max => value =>
isNaN(value) || value <= max ? undefined : `Should not be greater than ${max}`;

const maxFloatValue = max => value =>
isNaN(value) || isNaN(max) || Number.parseFloat(value) <= Number.parseFloat(max) ? undefined : `Should not be greater than ${max}`;

const mdrMinValue = min => value => {
  //console.log('TTTTTTTTTTTTTTT min: ' + min + ' value: ' + value);
  if (!value || !min)
    return undefined;
  
  let error = undefined;
  if (value >= min)
    return undefined;
  else 
    error = `Must be greater than ${min}`;
  //console.log('TTTTTTTTTTTTTTT min: ' + min + ' value: ' + value + ' result: ' + error);
  return error;
}
  

const validMinLength = length => value => (value &&  value.length < length ? 'Please Enter Minimum ' + length + ' characters.' : undefined);
const validMinLengthFormat = length => value => (value &&  value.length < length ? 'Invalid format.' : undefined);
const validMaxLength = length => value => (value &&  value.length > length ? 'Please Enter Maximum ' + length + ' characters.' : undefined);
const validEmail = value => (value && !value.match(/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/) ? t('Please enter a valid e-mail address') : undefined);
const validEmailRequired = value => (!value || (value && !value.match(/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/)) ? t('Please enter a valid e-mail address') : undefined);
const validSpecialCharacter = value => (value && !value.match(/^[0-9a-zA-Z \-'_]+$/) ? "Symbol are not supported: @#$^&" : undefined);
const validSpecialCharacterWithoutSpace = value => (value && !value.match(/^[0-9a-zA-Z\s]+$/) ? "Symbol are not supported: @#$^&" : undefined);
const composeValidators = (...validators) => value =>
  validators.reduce((error, validator) => error || validator(value), undefined);
// const validMinLength = validLength;

const validPreFix = frefixVal => value =>{ 
  if(value ){
    let prefixLengt = frefixVal.length
    if(value.substring(0, prefixLengt) !== frefixVal){
      return 'Value must start with '+ frefixVal;
    }
  }
  // (value.length > length ? 'Please Enter Maximum ' + length + ' characters.' : undefined);
  return undefined;
}
const validEndPreFix = frefixVal => value =>{ 
  if(value ){
    let prefixLengt = frefixVal.length
    if(value.substring(value.length - prefixLengt, value.length) !== frefixVal){
      return 'Value must end with '+ frefixVal;
    }
  }
  // (value.length > length ? 'Please Enter Maximum ' + length + ' characters.' : undefined);
  return undefined;
}
const validEqual0 = value => {
 if(Number(value)===0)
  return 'Should be greater than 0';
}


export default {
  required,
  mustBeNumber,
  mustBeNumberRequired,
  minValue,
  maxValue,
  minFloatValue,
  maxFloatValue,
  composeValidators,
  validMinLength,
  validMinLengthFormat,
  validMaxLength,
  validEmail,
  validEmailRequired,
  validSpecialCharacter,
  validSpecialCharacterWithoutSpace,
  validPreFix,
  validEndPreFix,
  validEqual0,
  mdrMinValue,
  validNotMatch,
  validNotMatchPassword
}